export const MapVectorJsonService = Symbol('MapVectorJsonService');
export interface MapVectorJsonService {
  isMapboxVectorStyle: boolean;
  getStyleUrl(): string;
  buildOpenLayersTileUrl(): string;
  getOpenLayersAttributions(): string | string[];
}
